import { Tooltip, ActionIcon } from "@mantine/core"
import { IconDownload } from "@tabler/icons-react"
import { useTranslation } from "react-i18next"
import { DownloadButton } from "./Buttons"

interface Props {
  src: string
  fileName: string
  variant?: "icon" | "button"
}

export function DownloadFileButton({
  fileName,
  src,
  variant = "button",
}: Props) {
  const { t } = useTranslation("app_server")
  function handleDownload() {
    const link = document.createElement("a")
    link.href = src
    link.download = fileName

    document.body.appendChild(link)

    link.click()

    document.body.removeChild(link)
  }
  return (
    <Tooltip label={t("Download")}>
      {variant === "button" ? (
        <DownloadButton onClick={handleDownload} />
      ) : (
        <ActionIcon variant="subtle" onClick={handleDownload}>
          <IconDownload />
        </ActionIcon>
      )}
    </Tooltip>
  )
}
